/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventBehaviorType } from './EventBehaviorType';
import {
	EventBehaviorTypeFromJSON,
	EventBehaviorTypeFromJSONTyped,
	EventBehaviorTypeToJSON,
	EventBehaviorTypeToJSONTyped,
} from './EventBehaviorType';

/**
 *
 * @export
 * @interface EventBehavior
 */
export interface EventBehavior {
	/**
	 *
	 * @type {EventBehaviorType}
	 * @memberof EventBehavior
	 */
	eventBehaviorType?: EventBehaviorType;
}

/**
 * Check if a given object implements the EventBehavior interface.
 */
export function instanceOfEventBehavior(value: object): value is EventBehavior {
	return true;
}

export function EventBehaviorFromJSON(json: any): EventBehavior {
	return EventBehaviorFromJSONTyped(json, false);
}

export function EventBehaviorFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventBehavior {
	if (json == null) {
		return json;
	}
	return {
		eventBehaviorType:
			json['eventBehaviorType'] == null
				? undefined
				: EventBehaviorTypeFromJSON(json['eventBehaviorType']),
	};
}

export function EventBehaviorToJSON(json: any): EventBehavior {
	return EventBehaviorToJSONTyped(json, false);
}

export function EventBehaviorToJSONTyped(
	value?: EventBehavior | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		eventBehaviorType: EventBehaviorTypeToJSON(value['eventBehaviorType']),
	};
}
